var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-information-loader" }, [
    _c(
      "div",
      { staticClass: "company-information-loader__labels" },
      [
        _c("CompassSkeleton", { attrs: { size: "x-large" } }),
        _vm._v(" "),
        _c("CompassSkeleton", { attrs: { size: "x-large" } }),
        _vm._v(" "),
        _c("CompassSkeleton", { attrs: { size: "x-large" } }),
        _vm._v(" "),
        _c("CompassSkeleton", { attrs: { size: "x-large" } })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "company-information-loader__fields" },
      [
        _c("CompassSkeleton", { attrs: { size: "x-large" } }),
        _vm._v(" "),
        _c("CompassSkeleton", { attrs: { size: "x-large" } }),
        _vm._v(" "),
        _c("CompassSkeleton", { attrs: { size: "x-large" } }),
        _vm._v(" "),
        _c("CompassSkeleton", { attrs: { size: "x-large" } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }